import React, { useEffect, useState } from "react";
import {
  ButtonBack,
  Container,
  Logo,
  ViewInput,
  ViewMax,
  ViewPartner,
  ViewProfile,
  ViewRow,
  ViewStats,
} from "./styles";
import logo from "./../images/logo.png";
import user from "./../images/user.png";
import { Button, ConfigProvider, Input, Pagination, Spin, Tooltip } from "antd";
import { useQuery } from "../hooks/Location";
import api from "../services/api";
import { toast } from "react-toastify";
import { Redes, RedesImage } from "../Profile/styles";
import { redesSociais } from "../Const";
import { format, addMinutes } from "date-fns";
import copy from "copy-to-clipboard";
import { IoIosCloseCircle, IoMdExit, IoMdHelpCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";

export default function Partner() {
  const query = useQuery();
  const navigate = useNavigate();

  const plans = {
    promocional: { id: "promocional", name: "Promocional", days: 365 },
    bronze: { id: "bronze", name: "Bronze", days: 90 },
    prata: { id: "prata", name: "Prata", days: 180 },
    ouro: { id: "ouro", name: "Ouro", days: 365 },
    "prime-90": { id: "prime-90", name: "Prime Trimestral", days: 90 },
    "prime-180": { id: "prime-180", name: "Prime Semestral", days: 180 },
    "prime-365": { id: "prime-365", name: "Prime Anual", days: 365 },
    "prime-vip": { id: "prime-vip", name: "Clube Prime Vip", days: 365 },
    "prime-promocional": {
      id: "prime-promocional",
      name: "Clube Promocional",
      days: 365,
    },
  };
  const [loading, setLoading] = useState(true);
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingProfiles, setLoadingProfiles] = useState(false);
  const [error, setError] = useState(false);
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [search, setSearch] = useState("");
  const [password, setPassword] = useState("");
  const [page, setPage] = useState(0);
  const [passwordVisible, setPasswordVisible] = useState(true);
  const [partner, setPartner] = useState({});

  useEffect(() => {
    getPartner(page, search);
  }, [page, token]);

  async function getPartner(page, search) {
    setLoadingProfiles(true);
    const token = await localStorage.getItem("@partner:token");
    if (token) {
      await api
        .get(`/partner/auth?page=${page}${search ? `&search=${search}` : ""}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setPartner(response.data);
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
          localStorage.removeItem("@partner:token");
          setToken("");
        });
      setToken(token);
    }
    setLoading(false);
    setLoadingProfiles(false);
  }

  async function loginPartner() {
    setLoadingLogin(true);
    await api
      .post("/session-partner", { email, password })
      .then((response) => {
        const token = response.data;
        localStorage.setItem("@partner:token", token);
        setToken(token);
        setEmail("");
        setPassword("");
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoadingLogin(false);
  }

  return (
    <Container>
      {loading ? (
        <Spin style={{ marginTop: 120 }} size="large" />
      ) : (
        <ViewMax>
          {token && (
            <>
              <ViewRow>
                <ButtonBack
                  disabled={loading}
                  onClick={() => {
                    localStorage.removeItem("@partner:token");
                    setToken("");
                  }}
                >
                  <IoMdExit color="#363636" size={25} />
                </ButtonBack>
                <Logo
                  src={logo}
                  style={{ height: 35, margin: 0, objectFit: "contain" }}
                />
              </ViewRow>
              <ViewPartner>
                <img
                  src={
                    partner.photo
                      ? `https://qrbio-api.s3.amazonaws.com/${partner.photo}`
                      : user
                  }
                />
                <div>
                  <p>Nome: {partner.name}</p>
                  <p>Nome Exibido: {partner.label}</p>
                  <Button
                    type="primary"
                    onClick={() => {
                      copy(
                        `https://qrbio.me/user/cadastro?partner=${partner.id}`,
                      );
                      toast.success("Link de indicação copiado com sucesso");
                    }}
                  >
                    Copiar Link de Indicação
                  </Button>
                </div>
              </ViewPartner>

              <h1>Disparos de Notificação</h1>
              <ViewStats>
                <div>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 5,
                    }}
                  >
                    Por Semana
                    <Tooltip
                      title={`Toda semana aos domingos você receberá mais ${partner.sends_week || 0} disparos.`}
                    >
                      <IoMdHelpCircle size={18} color="#fff" />
                    </Tooltip>
                  </p>
                  <span>{partner.sends_week || 0}</span>
                </div>
                <div>
                  <p>Disponíveis</p>
                  <span>{partner.number_sends || 0}</span>
                </div>
                <div>
                  <p>Intervalo</p>
                  <span>{partner.interval_send || 0} hrs</span>
                </div>
              </ViewStats>

              <Button
                type="primary"
                style={{
                  width: "95%",
                  height: 45,
                  marginBottom: 30,
                  borderRadius: 8,
                  fontWeight: "bold",
                  fontSize: 16,
                  backgroundColor: "#20D072",
                  borderColor: "#20D072",
                }}
                onClick={() => navigate("/user/parceiro/notificacoes")}
              >
                DISPARAR NOTIFICAÇÃO
              </Button>

              <p style={{ marginTop: 10 }}>Pesquisar Perfis</p>
              <ViewRow style={{ margin: "5px 0 15px 0" }}>
                <Input
                  placeholder="procurar por nome ou nickname"
                  allowClear={{
                    clearIcon: <IoIosCloseCircle color="#FFFFFF" size={15} />,
                  }}
                  onClear={() => {
                    setSearch("");
                    if (page) {
                      setPage(0);
                    } else {
                      getPartner(0, "");
                    }
                  }}
                  value={search}
                  style={{
                    width: "95%",
                    height: 35,
                    marginRight: 10,
                    fontSize: 14,
                  }}
                  onChange={(text) => {
                    setSearch(text.target.value);
                  }}
                />
                <Button
                  type="primary"
                  style={{
                    height: 35,
                  }}
                  onClick={() => {
                    if (page) {
                      setPage(0);
                    } else {
                      getPartner(0, search);
                    }
                  }}
                >
                  Pesquisar
                </Button>
              </ViewRow>
              {loadingProfiles ? (
                <Spin style={{ margin: "120px 0" }} size="large" />
              ) : (
                <>
                  <h1>{partner.profilesTotal} Perfis</h1>
                  {partner.profiles?.map((profile) => {
                    return (
                      <ViewProfile key={profile.id}>
                        <img
                          style={{ minWidth: "80px" }}
                          src={profile.photo ? profile.photo_url : user}
                        />
                        <div>
                          <p>{profile.name}</p>
                          <p style={{ marginBottom: 10 }}>
                            {profile.description}
                          </p>
                          <Button
                            type="primary"
                            onClick={() => {
                              window.open(
                                `https://qrbio.me/${profile.nickname}`,
                                "_blank",
                              );
                            }}
                          >
                            Ver Perfil
                          </Button>
                          {profile.sociais.map((item) => {
                            return (
                              <Redes
                                key={item.id}
                                style={{
                                  width: 25,
                                  height: 25,
                                  margin: "0 0 8px 7px",
                                }}
                                onClick={() => {
                                  if (item.name == "Instagram") {
                                    window.open(
                                      redesSociais[item.name].url +
                                        item.url.replaceAll("@", ""),
                                      "_blank",
                                    );
                                  } else {
                                    if (item.name == "Whatsapp") {
                                      window.open(
                                        redesSociais[item.name].url +
                                          item.url.replace(/\D/g, ""),
                                        "_blank",
                                      );
                                    } else {
                                      window.open(
                                        redesSociais[item.name].url + item.url,
                                        "_blank",
                                      );
                                    }
                                  }
                                }}
                              >
                                <RedesImage
                                  style={{ width: 25, height: 25 }}
                                  src={redesSociais[item.name].icon}
                                />
                              </Redes>
                            );
                          })}
                          <p>{plans[profile.plan_name]?.name || "Gratuito"}</p>
                          <span className="date">
                            Cadastrado em{" "}
                            {format(
                              new Date(profile.create_at),
                              "dd/MM/yyyy HH:mm",
                            )}
                          </span>
                        </div>
                      </ViewProfile>
                    );
                  })}
                </>
              )}
              {partner.profilesTotal > 30 && (
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#008037",
                      colorText: "#fff",
                      colorBgContainer: "#363636",
                    },
                    components: {
                      Pagination: {
                        itemActiveBg: "#363636",
                        itemActiveColor: "#fff",
                        itemLinkColor: "#fff",
                        itemLinkHoverColor: "#fff",
                        itemLinkBg: "transparent",
                        itemLinkHoverBg: "#1a1a1a",
                        itemHoverBg: "#1a1a1a",
                        itemHoverColor: "#fff",
                      },
                    },
                  }}
                >
                  <Pagination
                    style={{
                      margin: "25px 0",
                      alignSelf: "center",
                    }}
                    showSizeChanger={false}
                    current={page + 1}
                    pageSize={30}
                    onChange={(page) => {
                      setPage(page - 1);
                    }}
                    total={partner.profilesTotal}
                  />
                </ConfigProvider>
              )}
            </>
          )}
          {!token && (
            <>
              <Logo src={logo} />
              <ViewInput>
                <p>EMAIL</p>
                <Input
                  value={email}
                  status={error && !email && "error"}
                  placeholder="digite seu email"
                  inputMode="email"
                  autoCapitalize="off"
                  style={{
                    height: 40,
                    fontSize: 15,
                  }}
                  onChange={(e) => {
                    setEmail(e.target.value.replace(/ /g, "").toLowerCase());
                  }}
                />
              </ViewInput>
              <ViewInput style={{ marginTop: 15 }}>
                <p>SENHA</p>
                <Input.Password
                  value={password}
                  status={error && !password && "error"}
                  placeholder="digite sua senha"
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  autoCapitalize="off"
                  visibilityToggle={{
                    visible: passwordVisible,
                    onVisibleChange: setPasswordVisible,
                  }}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </ViewInput>
              <Button
                loading={loadingLogin}
                type="primary"
                style={{
                  marginTop: 30,
                  width: "90%",
                  fontSize: 16,
                  height: 40,
                  color: "#363636",
                  fontFamily: "Montserrat-Medium",
                }}
                onClick={() => {
                  loginPartner();
                }}
              >
                Entrar
              </Button>
            </>
          )}
        </ViewMax>
      )}
    </Container>
  );
}
